/** Options par défaut des toasts de la v2 (ChakraProvider de mountV2) : rendu V2Toast (lib/toast.tsx). */
import type { UseToastOptions } from '@chakra-ui/react';
import { V2Toast } from './toast';

export const V2_TOAST_DEFAULTS: UseToastOptions = {
  position: 'top-right',
  duration: 5000,
  render: (props) => <V2Toast {...(props as Parameters<typeof V2Toast>[0])} />,
  // La largeur est celle de V2Toast (fixe) : sans le minimum de 300 px de la coque de Chakra (escalier, 320 px).
  containerStyle: { minWidth: 0 },
};
